export default {
  namespaced  : true,
  state       : {
    parameters  : {
      hasMessage  : false,
      message     : 'フラッシュメッセージです。',
      status      : 'info',
      hasControl  : false,
      autoClose   : 1500,
    },
  },

  mutations   : {
    setFlashMessage(state, payload){
      state.parameters.hasMessage  = payload.hasMessage;
      state.parameters.message     = payload.message;
      state.parameters.status      = payload.status;
      state.parameters.hasControl  = payload.hasControl;
      state.parameters.autoClose   = payload.autoClose;
    },

    clearFlashMessage(state){
      state.parameters.hasMessage  = false;
      state.parameters.message     = 'フラッシュメッセージです。';
      state.parameters.status      = 'info';
      state.parameters.hasControl  = false;
      state.parameters.autoClose   = 1500;
    },

    resetStore(state){
      state.parameters.hasMessage = false;
      state.parameters.message    = 'フラッシュメッセージです。';
      state.parameters.status     = 'info';
      state.parameters.hasControl = false;
      state.parameters.autoClose  = 1500;
    }
  },
  
  actions   : {
    updateFlashMessage(context, payload){
      context.commit('setFlashMessage', payload);
    },
    
    clearFlashMessage(context){
      context.commit('clearFlashMessage');
    },
    
    resetStore(context){
      context.commit('resetStore');
    }
  }
}